module.exports = __webpack_public_path__ + "static/media/piggy-bank-graphic.25a38bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/result-page-images/piggy-bank-graphic.png
// module id = 355
// module chunks = 0